// extracted by mini-css-extract-plugin
export default {"payment":"zz","title_row":"Az","border_bottom":"Bz","promo_wrapper":"Cz","payment_wrapper":"Ez","label":"Fz","card_row":"Gz","cardcontain":"Hz","card_input":"Iz","card_error":"Jz","card_label":"Kz","lock":"Lz","same_address":"Mz","place_order_button":"Nz","buttonwrap":"Oz","hide_form":"Pz","paypal_buttons":"Qz","review_button":"Rz","alt_payment":"Sz"};
    if(module.hot) {
      // 1711717533330
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  